import {GET_FORM_SNAPSHOTS} from '../../../actions/Ares/actiontypes';
import {normalize} from '../../../util/utils';

export function aresSnapshotsReducer(state = {}, action) {
	switch (action.type) {
		case GET_FORM_SNAPSHOTS:
			return normalize(action.response);
		default:
			return state;
	}
}
